/* eslint-disable react/prop-types */
import React, { Component, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { resetRedirectForbidden } from './redux/actions/user';
import PublicRoute from './components/common/publicRoute';
import PrivateRoute from './components/common/privateRoute';
import Landing from './components/common/landing';
import NotFound from './components/common/notFound';
import WaitingComponent from './theme/waiting';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { REDIRECT_PATH_FORBIDDEN } from './constants/systemConstants';

import './assets/dependencies';
import { withRouter } from 'react-router-dom';

const Login = lazy(() => import('./components/common/login'));
const Lock = lazy(() => import('./components/common/lock'));
const Activate = lazy(() => import('./components/common/activate'));
const Register = lazy(() => import('./components/common/register'));
const AppRoutes = lazy(() => import('./appRoutes'));
const ForgotPassword = lazy(() => import('./components/forms/ForgotPassword'));
class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidUpdate(prevProps) {
    const { redirectToForbidden, history } = this.props;
    const wasForbidden = prevProps.redirectToForbidden.redirectTo403;
    const isNowForbidden = redirectToForbidden.redirectTo403;
    if (!wasForbidden && isNowForbidden) {
      history.push(REDIRECT_PATH_FORBIDDEN);
      this.props.resetRedirectForbidden();
    }
  }
  render() {
    return (
      <div>
        <Switch>
          <PublicRoute path="/" exact component={Landing} />
          <PublicRoute path="/login" component={WaitingComponent(Login)} />
          <PublicRoute path="/lock" component={WaitingComponent(Lock)} />
          <PublicRoute path="/activate" component={WaitingComponent(Activate)} />
          <PrivateRoute path="/app" component={WaitingComponent(AppRoutes)} />
          <PublicRoute path="/register" component={WaitingComponent(Register)} />
          <PublicRoute path="/forgot-password" component={WaitingComponent(ForgotPassword)} />
          <Route component={NotFound}/>
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  redirectToForbidden: state.user,
  resetRedirectForbidden: PropTypes.func.isRequired
});
Routes.propTypes = {
  history: PropTypes.object.isRequired
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ resetRedirectForbidden }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Routes));

